import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import style from './style.module.less';

const PackageDetails = ({ pack }) => {
  const {
    packageDetail: { packageName, dimensions, weight },
    items,
  } = pack;
  return (
    <>
      <div className={style.header}>
        <FormattedMessage {...messages.packageDetailsHeader} />
      </div>
      <div className={classNames(style['package-details'], style.underline)}>
        <div className={classNames(style['package-name'], style.value)}>{packageName}</div>
        <div className={style['package-information']}>
          <div>
            {dimensions.length} X {dimensions.width} X {dimensions.height}
          </div>
          <div>{weight.value}</div>
        </div>
      </div>
      <div className={style.label}>
        <FormattedMessage {...messages.itemsHeader} />
      </div>
      {items.map(({ sku }) => (
        <div key={sku} className={style.value}>
          {sku}
        </div>
      ))}
    </>
  );
};

PackageDetails.propTypes = {
  pack: PropTypes.shape({
    packageDetail: PropTypes.shape({
      packageName: PropTypes.string,
      dimensions: PropTypes.shape({
        length: PropTypes.number,
        width: PropTypes.number,
        height: PropTypes.number,
      }),
      weight: PropTypes.shape({
        value: PropTypes.number,
      }),
    }),
    items: PropTypes.arrayOf(
      PropTypes.shape({
        sku: PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default PackageDetails;
